import { render, staticRenderFns } from "./thirdStatus.vue?vue&type=template&id=45fc8fe8"
import script from "./thirdStatus.vue?vue&type=script&lang=js"
export * from "./thirdStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fc8fe8')) {
      api.createRecord('45fc8fe8', component.options)
    } else {
      api.reload('45fc8fe8', component.options)
    }
    module.hot.accept("./thirdStatus.vue?vue&type=template&id=45fc8fe8", function () {
      api.rerender('45fc8fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/thirdStatus.vue"
export default component.exports